// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,  
  clientId: '726926b39b38467a8b0eef697d6dc004',
  url: 'http://playerpoints.net:50455/rest/V1',
  login: '/creditsystem/customer/login',
  customer: '/gs/customer',
  assignCard: '/creditsystem/assign/card',
  assignTicket: '/creditsystem/redeem/email',
  clubCard: '/creditsystem/card/email?code=',
  redeemed: '/creditsystem/is/redeemed?code='
};



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/environments/environment.ts